// spawn_task — raises a follow-up (e.g. future work opportunity) and adds it to the client's comments.
import React, { useState } from 'react';
import { ListPlus, CheckCircle2 } from 'lucide-react';
import { StepCard, StepNav, ErrorLine, api, readKey, humanise } from './_stepKit';

export default function SpawnTask({ action, value, onChange, onNext, onBack, canBack, capturedData }) {
  const p = action.params || {};
  const seeded = readKey(capturedData, p.seed_data) || readKey(capturedData, 'future_opportunities.description') || '';
  const [note, setNote] = useState(value?.note ?? (typeof seeded === 'string' ? seeded : ''));
  const [done, setDone] = useState(value?.followup_id ? value : null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const raise = async () => {
    setBusy(true); setErr('');
    try {
      const { data } = await api.post('/workflow/side-effects/spawn-task', {
        appraisal_id: capturedData?.appraisal_id, target_status: p.target_status, task_type: p.task_type, seed_data: p.seed_data, note,
      });
      setDone(data); onChange(data);
    } catch (e) { setErr(e?.response?.data?.detail || e.message || 'Could not raise the follow-up'); } finally { setBusy(false); }
  };

  return (
    <div>
      <StepCard icon={ListPlus} title={`Raise follow-up · ${humanise(p.seed_data || p.task_type)}`} testid="wf-spawn-task">
        <div className="text-xs text-slate-500">Saved as an open follow-up{p.target_status ? ` for ${humanise(p.target_status)}` : ''} and added to the client's comments.</div>
        <textarea rows={3} value={note} disabled={!!done} onChange={(e) => setNote(e.target.value)} data-testid="wf-spawn-task-note"
          className="w-full border border-slate-300 rounded p-2 text-sm disabled:bg-slate-50" placeholder="What's the opportunity? Leave blank to skip." />
        {done ? (
          <div className="text-sm text-emerald-700 flex items-center gap-1.5" data-testid="wf-spawn-task-done"><CheckCircle2 size={15} /> Follow-up raised</div>
        ) : (
          <button onClick={raise} disabled={busy || !note.trim()} data-testid="wf-spawn-task-raise"
            className="px-4 py-2 rounded bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700 disabled:opacity-40 transition-colors">
            {busy ? 'Saving…' : 'Raise follow-up'}
          </button>
        )}
        <ErrorLine err={err} testid="wf-spawn-task-err" />
      </StepCard>
      <StepNav canBack={canBack} onBack={onBack} onNext={onNext} label={done || note.trim() ? 'Next →' : 'Skip →'} disabled={!done && !!note.trim()} />
    </div>
  );
}
